import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subscription, of } from 'rxjs';
import { MyAddressBookService } from 'src/app/services/feature/kb-My-Address-Book/kb-my-address-book.service';
import { DeletePopup2Component } from '../delete-popup2/delete-popup2.component';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-kb-my-addressbook',
  templateUrl: './kb-my-addressbook.component.html',
  styleUrls: ['./kb-my-addressbook.component.scss'],
  standalone: false
})
export class KbMyAddressbookComponent {
  addressBook$: Observable<any> = this.service.getApi();
  addAddress: string = 'add-address';
  isMobile: boolean = false;
  sub = new Subscription();
  searchInput: string = '';
  constructor(private service: MyAddressBookService,
    private breakpointObserver: BreakpointObserver,
    private matdialog: MatDialog,
    private router: Router,
    private globalmsgService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private scroller: ViewportScroller,
    private matDialog: MatDialog) {
    this.sub.add(
      this.breakpointObserver
        .observe([Breakpoints.XSmall, Breakpoints.Small])
        .subscribe((result) => {
          this.isMobile = result.matches;
        }));
  }

  openDeleteDialog(address) {
    const dialogRef = this.matdialog.open(DeletePopup2Component, {
      data: { address },
    });
    this.sub.add(dialogRef.afterClosed().subscribe((data) => {
      if (data?.message?.status == "SUCCESS") {
        this.globalmsgService.add({ key: data.message.message }, GlobalMessageType.MSG_TYPE_INFO);
        this.getAddress('', 0);
      }
    }));

  }
  openEditpage(id) {
    this.router.navigate(['add-edit-address'], {
      queryParams: { Id: id },
    });
  }
  changePageCustom(searchText, e, data) {
    this.getAddress(searchText, e);
  }
  getAddress(searchText?, currentPage?) {

    this.sub.add(this.service.getAddressAfterSearch(searchText, currentPage).subscribe(data => {
      this.addressBook$ = of(data);
      this.scroller.scrollToPosition([0, 250]);
      this.cdr.detectChanges();
    }));
  }
  searchApi(key, currentPage) {
    this.getAddress(key, currentPage);
  }
  searchResetter() {
    if (this.searchInput.length == 0) {
      this.getAddress('', 0);
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
